import type { Resolvers } from "owa-graph-schema";
import type * as lazyFunctions from "./lazyFunctions";
import { LazyBootModule, LazyImport } from "owa-bundling-light";

const lazyModule: LazyBootModule<typeof lazyFunctions> = new LazyBootModule<typeof lazyFunctions>(() => import(/* webpackChunkName: "OwaMessageFileResolver" */ "./lazyFunctions"), { name: "OwaMessageFileResolver" });

export const lazyMessageFileResolvers: LazyImport<Promise<Resolvers>, LazyBootModule<typeof lazyFunctions>> = new LazyImport(lazyModule, m => m.lazyMessageFileResolvers.import());
